import React, { useEffect, useState } from 'react'
import noteTransposer, { TransposeKey } from '../../utils/NoteTransposer'

export default function TransposeButtons({
  initialKey,
  transposeKeys,
  setTransposeKeys,
}: {
  transposeKeys: TransposeKey[]
  setTransposeKeys: React.Dispatch<React.SetStateAction<TransposeKey[]>>
  initialKey: TransposeKey;
}
) {

  useEffect(() => {
    toggleTransposeKey(initialKey)
  }, [])

  function toggleTransposeKey(newKey: TransposeKey) {
    setTransposeKeys((prevTransposeKeys) => {
      const containsKey = prevTransposeKeys.indexOf(newKey) !== -1
      const newKeys = containsKey ? prevTransposeKeys.filter(prevKey => prevKey !== newKey) : [...prevTransposeKeys, newKey]
      return newKeys
    })
  }

  return (
    <div className="flex flex-wrap gap-1">
      {noteTransposer.keys().map((key: TransposeKey) => (
        <button
          key={key}
          onClick={() => toggleTransposeKey(key)}
          className={[
            'px-2 py-1 text-sm rounded transition-colors',
            transposeKeys.includes(key)
              ? 'bg-blue-500 text-white hover:bg-blue-600'
              : 'bg-gray-700 text-gray-100 hover:bg-gray-600',
          ].join(' ')}
        >
          {key}
        </button>
      ))}
    </div>
  )
}

